<template>
	<el-dialog :close-on-click-modal="false" :visible.sync="dialogVisible" title="意见反馈" width="600px" @close="handleClose">
		<el-form ref="feedbackForm" :model="form" label-position="top">
			<!-- <el-form-item label="评分" prop="score">
				<el-slider v-model="form.score" :marks="marks" :max="10" :min="0" :step="1" show-stops> </el-slider>
			</el-form-item> -->

			<el-form-item prop="reason">
				<el-input v-model="form.reason" :rows="4" maxlength="500" placeholder="请详细描述您的意见或建议..." show-word-limit style="border: 1px solid #f1f5f9" type="textarea" />
			</el-form-item>
		</el-form>

		<span slot="footer" class="dialog-footer">
			<el-button size="small" @click="handleCancel">取消</el-button>
			<el-button size="small" type="primary" @click="handleSubmit">提交</el-button>
		</span>
	</el-dialog>
</template>

<script>
	import { feedback } from '@/api/ai/ai.js';
	import TMessage from '@/utils/TMessage';
	export default {
		name: 'FeedBack',
		props: {
			visible: {
				type: Boolean,
				default: false
			},
			messagesId: {
				type: String,
				default: ''
			}
		},
		data() {
			return {
				form: {
					score: 0,
					reason: '',
					message_id: null
				},
				rules: {
					score: [{ required: true, message: '请进行评分', trigger: 'change' }]
				},
				marks: {
					0: '0',
					1: '1',
					2: '2',
					3: '3',
					4: '4',
					5: '5',
					6: '6',
					7: '7',
					8: '8',
					9: '9',
					10: '10'
				}
			};
		},
		computed: {
			dialogVisible: {
				get() {
					return this.visible;
				},
				set(val) {
					this.$emit('update:visible', val);
				}
			}
		},
		watch: {
			visible(val) {
				if (val) {
					this.form = {
						score: 0,
						reason: '',
						message_id: null
					};
				}
			}
		},
		methods: {
			handleSubmit() {
				this.$refs.feedbackForm.validate(valid => {
					if (valid) {
						this.form.message_id = this.messagesId;
						feedback(this.form).then(res => {
							TMessage.success('反馈提交成功');
							this.$emit('submitFeedback', this.form);
							this.handleClose();
						});
					} 
				});
			},

			handleCancel() {
				this.dialogVisible = false;
			},

			handleClose() {
				// this.$refs.feedbackForm.resetFields();
				this.$emit('cancel');
			}
		}
	};
</script>

<style lang="less" scoped>
	// Dialog header 样式优化
	::v-deep .el-dialog__header {
		border-bottom: 1px solid #ebeef5;
		background-color: #f5f7fa;
		padding: 15px 20px;
	}

	.dialog-header {
		font-size: 16px;
		font-weight: 600;
		color: #303133;
	}

	// Dialog footer 样式优化
	::v-deep .el-dialog__footer {
		border-top: 1px solid #ebeef5;
		padding: 15px 20px;
	}

	.dialog-footer {
		display: flex;
		justify-content: flex-end;
		gap: 10px;
	}

	// 表单样式优化
	::v-deep .el-form {
		padding: 20px;
	}

	::v-deep .el-form-item__label {
		color: #606266;
		font-size: 14px;
	}

	::v-deep textarea {
		border: 1px solid #f1f5f9;

		&:focus {
			border-color: #409eff;
		}
	}

	::v-deep .el-slider__marks-text {
		white-space: nowrap;
	}
</style>
